import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { FormSection } from "redux-form";
import { TextField } from "jbc-front/components/Form";
import {
  isThai,
  isEnglish,
  isNumber,
  isRequired,
} from "../../../utils/CustomValidators";
import { withTranslation } from "react-i18next";
import styles from "./BankBranches.scss";
import FlashMessage from "src/components/FlashMessage/FlashMessage";

class BankBranches extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSuccess: false,
      isOpen: false
    }
  }

  render() {
    const { t, handleSubmit,  } = this.props;
    const bankBranches = this.props.bankBranch;

    const onSubmit = (values) => {
      axios.post('/desk/bank_branches', {
        bank_id: values.bankBranches.bank_id,
        branch_code: values.bankBranches.branch_code,
        name: values.bankBranches.name,
        name_eng: values.bankBranches.name_eng
      })
      .then((response) => {
        if (response.status === 200) {
            this.props.setOpen();
            this.props.setSuccess();
            setTimeout(() => {
              window.location.replace("/desk");
            }, 1000)
        }
      })
      .catch((error) => {
        this.props.setOpen();
        this.props.setUnSuccess();
      });
    }

    return (
      <React.Fragment>
        <FlashMessage 
          successMessage="Completed to register bank branch data." 
          failedMessage="Failed to register data. The data sent already exists in the database"
        />

        <div className={styles.bankBranches}>
          <h2>Add bank branch</h2>

          <form onSubmit={handleSubmit(onSubmit)}>
            <FormSection name="bankBranches">
            <div className='form-group u-mb15 u-mt30'>
              <label htmlFor='bank_id' className='control-label font-weight-bold'>
                Bank <span className='text-danger'>(Required)</span>
              </label>
              <br />

              <Field
                name='bank_id'
                component='select'
                className={styles.option}
                required
              >
                <option />
                {bankBranches.map((bankBranch, index) => (
                  <option key={bankBranch.id} value={index + 1}>
                    {bankBranch.nameEng}
                  </option>
                ))}
              </Field>
            </div>

            <div className='form-group u-mb15'>
              <label
                htmlFor='branch_code'
                className='control-label font-weight-bold'
              >
                Branch Code <span className='text-danger'>(Required)</span>
              </label>
              <br />

              <TextField
                name='branch_code'
                type='text'
                maxLength='4'
                validate={[isRequired, isNumber]}
              />
            </div>

            <div className='form-group u-mb15'>
              <label htmlFor='name' className='control-label font-weight-bold'>
                Branch Name Thai <span className='text-danger'>(Required)</span>
              </label>
              <br />
              
              <TextField
                name='name'
                type='text'
                maxLength='100'
                validate={[isThai, isRequired]}
              />
            </div>

            <div className='form-group u-mb15'>
              <label
                htmlFor='branch_name_en'
                className='control-label font-weight-bold'
              >
                Branch Name English
              </label>
              <br />

              <TextField
                name='name_eng'
                type='text'
                maxLength='100'
                validate={isEnglish}
              />
            </div>

              <button className='btn btn-success' type="submit">Submit</button>

            </FormSection>
          </form>
        </div>
      </React.Fragment>
          
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSuccess: state.flashMessage.isSuccess,
    isOpen: state.flashMessage.isOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccess: () => dispatch({type: 'SET_SUCCESS'}),
    setUnSuccess: () => dispatch({type: 'SET_UNSUCCESS'}),
    setOpen: () => dispatch({type: 'SET_OPEN'}) 
  }
}

export default reduxForm({
  form: "bankBranches",
})(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BankBranches)));
